// @TODO: Backend doesn't provide dealer status yet, then 'undefined' is live. Remove it later

export const isBlocked = dealer =>
  dealer && dealer.status !== undefined && dealer.status.toLowerCase() === 'blocked';
export const isSuspended = dealer =>
  dealer && dealer.status !== undefined && dealer.status.toLowerCase() === 'suspended';
export const isBlockedOrSuspended = dealer => isBlocked(dealer) || isSuspended(dealer);
/**
 * This function will check if the dealer is enabled and not blocked or suspended.
 * Not sure if it's the best name
 * @param {object} dealer
 */
export const isTotallyEnabled = dealer => dealer.isEnabled && !isBlockedOrSuspended(dealer);



// WEBPACK FOOTER //
// ../utils/functions/is-dealer-blocked-or-suspended.js